<script setup lang="ts">
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>

<template>
  <router-view />
  <div class="loading-home h-screen w-full">
    <div
      class="h-full w-full flex flex-wrap flex-col justify-center items-center"
    >
      <div
        class="spinner-border animate-spin inline-block w-16 h-16 rounded-full text-red-700"
        role="status"
      >
        <span class="invisible">{{ t("reader.loading") }}</span>
      </div>
      <span class="error-message w-full text-center mt-5 px-5">{{
        t("reader.loading")
      }}</span>
    </div>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.loading-home {
  background-color: var(--DM__theme-bg-color);
}
</style>
